module.exports = __webpack_public_path__ + "img/corner-left-up.f3e96fc5.svg";